<template>
<div>
    <mail-send-form ref="mailSendForm" @mailEmitValue="mailEmitValueFunction"></mail-send-form>
    <trademark-form ref="trademarkForm"></trademark-form>
    <b-modal v-if="showLanguageSelect" size="xs" centered id="exportLanguageSelectModal" hide-footer>
        <b-col class="text-right" style="text-align-last: center;">
            <div class="d-inline-flex align-items-center">
                <b-button-group size="sm">
                    <b-button class="mr-1" variant="outline-primary" size="sm" @click="exportExcel('tr')">{{ $t('excel.turkish') }}</b-button>
                    <b-button variant="outline-info" size="sm" @click="exportExcel('en')">{{ $t('excel.english') }}</b-button>
                </b-button-group>
            </div>
        </b-col>
    </b-modal>
    <b-row class="align-items-center mb-1">
        <b-col class="d-flex align-items-center col-lg-8">
            <b-col class="col-md-3 mb-1">
                <label for="date-end-input">{{ $t('trademarkRenewalReport.date_start') }}</label>
                <b-form>
                    <CustomDatePicker :datePickerValidateOption="0" name="date-start-input" v-model="nextRenewalDateStart"></CustomDatePicker>
                </b-form>
            </b-col>
            <b-col class="col-md-3 mb-1">
                <label for="date-end-input">{{ $t('trademarkRenewalReport.date_end') }}</label>
                <b-form>
                    <CustomDatePicker :datePickerValidateOption="0" name="date-end-input" v-model="nextRenewalDateEnd"></CustomDatePicker>
                </b-form>
            </b-col>
            <b-col class="col-md-3 mb-2">
                <label for="employee-input">{{ $t('trademarkRenewalReport.employee') }}</label>
                <b-form-select id="employee-input" v-model="employeeSelect" @change="getTrademarkRenewalReportList()" v-on:keyup.enter="getTrademarkRenewalReportList()" size="sm" value-field="id" text-field="name" :options="employeeOption" />
            </b-col>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-4 mt-2">
            <b-button style="float:right;" class="d-inline-block mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getTrademarkRenewalReportList()" @click="getTrademarkRenewalReportList()">{{ $t('trademarkRenewalReport.list') }}</b-button>
            <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" v-b-modal.exportLanguageSelectModal @click="showLanguageSelect = true">
                {{ $t('excel.excel') }}
            </b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="trademarkRenewalReportTable" ref="trademarkRenewalReportTable" :columns="columns" :rows="rows" :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'trademarkApplicationNo'" class="text-nowrap">
                {{ $t('trademarkRenewalReport.trademark_application_no') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.trademarkId)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <span>
                        <b-button v-b-tooltip.html :title="$t('trademarkRenewalReport.send_reminder_mail')" variant="success" class="btn-icon mb-1 ml-1" size="sm" @click="showMailForm(props.row)">
                            <feather-icon icon="MailIcon" />
                        </b-button>
                    </span>
                </span>
            </span>
            <span v-else-if="props.column.field === 'nextRenewalDate'">
                <span>
                    {{ $formatFn(props.row.nextRenewalDate) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'trademarkOwnerList'">
                <b-col>
                    <b-row v-for="owner in props.row.trademarkOwnerList" v-bind:key="owner.id" style="font-size: small;">
                        <tr v-if="props.row.trademarkOwnerList.length != 1">
                            <feather-icon class="featherIconReSize" icon="ArrowRightIcon" />
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                        <tr v-else-if="props.row.trademarkOwnerList.length == 1">
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                    </b-row>
                </b-col>
            </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <!-- ,'100', '1000' -->
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getTrademarkRenewalReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        trademarkId: Number,
        getTrademarkList: {
            type: Function
        },
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('trademarkRenewalReport.trademark_record_no'),
                    field: 'trademarkRecordNo',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_name'),
                    field: 'trademarkName',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_application_no'),
                    field: 'trademarkApplicationNo',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_register_no'),
                    field: 'trademarkRegisterNo',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_next_renewal_date'),
                    field: 'nextRenewalDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_status'),
                    field: 'trademarkStatus',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_agent'),
                    field: 'trademarkAgent',
                },
                {
                    label: this.$t('trademarkRenewalReport.trademark_owner'),
                    field: 'trademarkOwnerList',
                },
                {
                    label: this.$t('trademarkRenewalReport.employee'),
                    field: 'employee',
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            pageLength: 100,
            pageNo: 1,
            nextRenewalDateStart: '',
            nextRenewalDateEnd: '',
            total: 0,
            employeeSelect: 0,
            employeeOption: [],
            rowsForExcel: [],
            showLanguageSelect: false,
            columnsForExcel: [{
                    key: 'trademarkRenewalReport.trademark_record_no',
                    field: 'trademarkRecordNo',
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent_reference_no',
                    field: 'trademarkAgentReferenceNo',
                },
                {
                    key: 'trademarkRenewalReport.trademark_application_no',
                    field: 'trademarkApplicationNo',
                },
                {
                    key: 'trademarkRenewalReport.trademark_register_no',
                    field: 'trademarkRegisterNo',
                },
                {
                    key: 'trademarkRenewalReport.trademark_application_date',
                    field: 'trademarkApplicationDate',
                    formatFn: this.$formatFn
                },
                {
                    key: 'trademarkRenewalReport.trademark_name',
                    field: 'trademarkName',
                },
                {
                    key: 'trademarkRenewalReport.trademark_nice_class',
                    field: 'trademarkNiceClassList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_next_renewal_date',
                    field: 'nextRenewalDate',
                    formatFn: this.$formatFn
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent',
                    field: 'trademarkAgent',
                },
                {
                    key: 'trademarkRenewalReport.trademark_owner',
                    field: 'trademarkOwnerList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent_responsible_to_mail',
                    field: 'trademarkAgentResponsibleTOMailList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent_responsible_cc_mail',
                    field: 'trademarkAgentResponsibleCCMailList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent_client_note',
                    field: 'trademarkAgentClientNoteList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_owner_note',
                    field: 'trademarkOwnerClientNoteList',
                },
                {
                    key: 'trademarkRenewalReport.trademark_renewal_agent',
                    field: 'trademarkRenewalAgent',
                },
                {
                    key: 'trademarkRenewalReport.trademark_agent_currency_code',
                    field: 'trademarkAgentCurrencyCode',
                },
                {
                    key: 'trademarkRenewalReport.mail_template_name',
                    field: 'mailTemplateName',
                },
            ]
        }
    },
    mounted() {
        this.nextRenewalDateStart = new Date().toJSON()
        this.nextRenewalDateEnd = new Date().toJSON()
        this.getTrademarkRenewalReportList()
    },
    methods: {
        async getInfo(trademarkId) {
            this.$refs.trademarkForm.showInfo(trademarkId)
        },
        getTrademarkRenewalReportList() {
            this.rows = []
            const data = {
                nextRenewalDateStart: this.nextRenewalDateStart,
                nextRenewalDateEnd: this.nextRenewalDateEnd,
                employeeId: this.employeeSelect,
                pageLength: this.pageLength,
                pageNo: this.pageNo
            }
            const controller = {
                name: 'Trademark',
                actionName: 'GetTrademarkRenewalPrepareMailReport'
            }
            const payload = {
                controller: controller,
                data: data
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.trademarkRenewalPrepareMailReportList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.total = response.data.total
                    this.employeeOption = response.data.employeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        showMailForm(row) {
            const data = {
                trademarkId: row.trademarkId,
                employeeId: localStorage.getItem('EmployeeId')

            }
            const controller = {
                name: 'MailTemplate',
                actionName: 'PrepareTrademarkRenewalMail'
            }
            const payload = {
                controller: controller,
                data: data
            }
            if (row.classAndOwnerConflictCheck) {
                this.$TrademarkRenewalConflictConfirm().then(result => {
                    if (result.value) {
                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$refs.mailSendForm.showInfo(response.data, trademarkId)
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }
                        })
                    }
                })
            } else {
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$refs.mailSendForm.showInfo(response.data, row.trademarkId)
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            }
        },
        exportExcel(lang) {
            let loader = this.$loading.show()
            this.rowsForExcel = []
            const data1 = {
                nextRenewalDateStart: this.nextRenewalDateStart,
                nextRenewalDateEnd: this.nextRenewalDateEnd,
                employeeId: this.employeeSelect,
                pageLength: this.total,
                pageNo: 1
            }
            const controller1 = {
                name: 'Trademark',
                actionName: 'GetTrademarkRenewalPrepareMailReport'
            }
            const payload1 = {
                controller: controller1,
                data: data1
            }
            this.$store.dispatch('moduleAuth/customService', payload1).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.trademarkRenewalPrepareMailReportList.forEach(element => {
                        this.rowsForExcel.push(element)
                    })
                    const columnsTranslated = this.columnsForExcel.map(col => {
                        const translatedLabel = this.$t(col.key, lang)
                        return {
                            ...col,
                            label: translatedLabel
                        }
                    })
                    const controller = {
                        name: 'Trademark',
                        actionName: 'CanExport'
                    }
                    const data = {
                        columnList: columnsTranslated.filter(p => p.field != 'logo'),
                        dataList: this.rowsForExcel
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            const filename = lang === 'tr' ? 'Marka Yenileme' : 'Trademark Renewal'
                            this.$downloadFile(filename, response.data.base64, 'xlsx')
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                        loader.hide()
                        this.showLanguageSelect = false
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        mailEmitValueFunction(mailEmitValue) {
            var controller = {
                name: 'Job',
                actionName: 'SaveJobAfterTrademarkRenewalMail'
            }
            var data = {
                trademarkId: mailEmitValue.recordId,
                employeeId: localStorage.getItem('EmployeeId')
            }
            var payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {

                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
